// extracted by mini-css-extract-plugin
export var anchor = "_32-0";
export var discard = "_32-4";
export var muiTooltipTooltip = "_32-6";
export var notificationBar = "_32-3";
export var saveButtonHoverSlotWrapper = "_32-5";
export var show = "_32-2";
export var spacer = "_32-1";